import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout'
import {Component, inject, OnInit, output} from '@angular/core'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {FileUploadComponent, IFileUpload} from '@sparbanken-syd/spb-file-mgmt'
import {DocumentService} from '../../../services/document.service'

@Component({
  selector: 'spb-upload-select',
  imports: [
    FileUploadComponent
  ],
  templateUrl: './upload-select.component.html',
  styleUrls: ['./upload-select.component.scss']
})
export class UploadSelectComponent implements OnInit {
  public files = output<IFileUpload>()
  public service = inject(DocumentService)
  public noDrag = false

  private readonly breakpointObserver = inject(BreakpointObserver)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(this.takeUntilDestroyed())
      .subscribe(result => this.noDrag = result.matches
      )
  }
}